/* =========================================================================
   Filters without the blink — category and sub-category listing pages.

   Applying a filter, a sort or a "Clear all" used to be a full page load:
   the whole screen went white and came back scrolled to the filter bar.
   This keeps the same URLs and the same Shopify filtering, but fetches the
   next page in the background and swaps only what changed — the filter
   bar, the applied-filter chips, the product grid, the count under the
   title and the all-filters sheet — with a short cross-fade while the
   rest of the page stays exactly where it is.

   Also: the all-filters sheet now slides up and down instead of popping,
   and the pill dropdowns ease in (CSS in vro-personalization.css).

   Add-on only. The filter form, its inline onchange submits, custom.js's
   pill panels and chip buttons and plp-category.js's sheet all keep
   working as they did; this sits in front of them and, if anything at all
   goes wrong, lets the browser do the full page load it always did.
   ========================================================================= */
(function () {
  'use strict';
  if (window.VroFilterMotion) return;

  var FORM_SEL = '#FacetFiltersForm, .plp-sheet-form';
  var GRID_SEL = '[data-vro-plp-grid-wrap], [data-vro-shopby-grid]';
  var busy = null;

  /* Parameters the page's own scripts own, not the filter form: the
     Shop-by picks (?shop=, assets/vro-plp-shopby.js) and the in-page
     question's answer (?vroq=, assets/vro-plp-quiz.js). The form only
     knows its own fields, so a GET submit used to drop both — picking
     "Cotton" and then a size threw the fabric answer away, and picking a
     size threw "Cotton" away the other way round. They ride along on
     every filter URL instead, so the question and the filters combine:
     the shelf is filtered by the form, then narrowed by the answer. */
  /* luxe: the circle picked on VRO Luxe (sections/vro-luxe-subcat.liquid).
     Dropping it on a filter threw the shopper's "Watches" away the moment
     they picked a country. */
  /* vro: a quiz answer narrowing a listing's grid (assets/vro-plp.js) — a
     filter used to reload without it and drop the answer. type, vro_cat,
     vro_brand: the search page's own (sections/main-search.liquid) —
     without type=product Shopify returns no product filters, and losing
     vro_brand re-armed the brand redirect. */
  var CARRY = ['shop', 'vroq', 'luxe', 'vro', 'type', 'vro_cat', 'vro_brand'];

  function carry(url) {
    var here = new URLSearchParams(window.location.search);
    CARRY.forEach(function (k) {
      if (here.has(k) && !url.searchParams.has(k)) url.searchParams.set(k, here.get(k));
    });
    return url;
  }

  function motion() { return window.VroMotion || null; }
  function reduced() { var m = motion(); return m ? m.reduced() : false; }

  function page() { return document.querySelector('.clp, .plp'); }

  function sectionOf(el) {
    var host = el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
    return host ? host.id.replace('shopify-section-', '') : '';
  }

  /* Anything else on the page that owns the grid right now — an in-page
     Shop-by pick, a quiz answer carried in on ?vro=, an answered goal
     question narrowing the grid — would be lost by a partial swap, so
     those keep the old full page load. */
  function canSwap(url) {
    var root = page();
    if (!root || !window.fetch || !window.DOMParser || !window.history || !history.pushState) return false;
    if (!document.querySelector(GRID_SEL)) return false;
    var here = new URLSearchParams(window.location.search);
    var next = new URLSearchParams(url.search);
    /* ?vroq= too: the answered question rebuilds the grid client-side
       from the filtered shelf, which a server-rendered swap would undo. */
    if (here.has('shop') || here.has('vro') || here.has('vroq') ||
        next.has('shop') || next.has('vro') || next.has('vroq')) return false;
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return false;
    var status = document.querySelector('[data-vro-shopby-status]');
    if (status && !status.hidden) return false;
    var answered = document.querySelector('[data-vro-facet].vro-facet-answered');
    if (answered && answered.querySelector('.clp-grid')) return false;
    return true;
  }

  /* The rare case that still reloads (a home-rail answer on ?vro=, an
     answered goal question) comes back where the shopper was, not at the
     top of the page — and theme.liquid's cross-document view transition
     fades between the two instead of flashing white. */
  var SCROLL_KEY = 'vro-filter-scroll';
  function fullLoad(url) {
    try {
      sessionStorage.setItem(SCROLL_KEY, JSON.stringify({ p: url.pathname, y: window.pageYOffset }));
    } catch (e) { /* ignore */ }
    window.location.href = url.toString();
  }
  function restoreScroll() {
    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(SCROLL_KEY) || 'null');
      sessionStorage.removeItem(SCROLL_KEY);
    } catch (e) { saved = null; }
    if (!saved || saved.p !== window.location.pathname) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, saved.y || 0);
  }

  /* The Shop-by rows or the in-page question own the grid (?shop= /
     ?vroq=). The server's grid would undo their answer, so instead the
     bar, chips, counts and sheet are swapped from the server and the grid
     is handed back to assets/vro-plp-shopby.js, which rebuilds it from the
     now-filtered shelf — no reload, the answer stays standing. */
  function ownedByRows(url) {
    var shop = window.VroPlpShopBy;
    if (!shop || !shop.refresh || !shop.setOriginal) return false;
    if (!document.querySelector('[data-vro-shopby-grid]')) return false;
    if (!window.fetch || !window.DOMParser || !history.pushState) return false;
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return false;
    var here = new URLSearchParams(window.location.search);
    var next = new URLSearchParams(url.search);
    if (here.has('vro') || next.has('vro')) return false;
    var answered = document.querySelector('[data-vro-facet].vro-facet-answered');
    if (answered && answered.querySelector('.clp-grid')) return false;
    return true;
  }

  function formUrl(form) {
    var action = form.getAttribute('action');
    var url = new URL(action || window.location.pathname, window.location.href);
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (typeof value === 'string') params.append(key, value);
    });
    url.search = params.toString();
    return carry(url);
  }

  /* ---------- the swap ------------------------------------------------ */
  function swapNode(oldEl, newEl) {
    if (!oldEl && !newEl) return;
    if (oldEl && newEl) {
      oldEl.innerHTML = newEl.innerHTML;
      Array.prototype.forEach.call(newEl.attributes, function (a) {
        if (a.name !== 'id' && a.name !== 'hidden') oldEl.setAttribute(a.name, a.value);
      });
    }
  }

  function swapChips(form, doc) {
    /* The chips are the form's next sibling when there are any. */
    var host = form.parentNode;
    var now = host ? host.querySelector(':scope > .clp-active-filters') : null;
    var newForm = doc.querySelector('#' + form.id);
    var next = newForm && newForm.parentNode
      ? newForm.parentNode.querySelector(':scope > .clp-active-filters') : null;
    if (now && next) { now.innerHTML = next.innerHTML; return; }
    if (now && !next) { now.remove(); return; }
    if (!now && next && host) host.insertBefore(document.importNode(next, true), form.nextSibling);
  }

  function initBanners(scope) {
    if (typeof window.Swiper === 'undefined') return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-plp-banner]'), function (el) {
      if (el.swiper) return;
      var slides = el.querySelectorAll('.swiper-slide').length;
      new window.Swiper(el, {
        slidesPerView: 1, spaceBetween: 0, speed: 400, loop: slides > 1,
        pagination: slides > 1 ? { el: el.querySelector('[data-plp-banner-dots]'), clickable: true } : false,
        autoplay: slides > 1 ? { delay: 4000, disableOnInteraction: false } : false,
        observer: true, observeParents: true
      });
    });
  }

  /* Bar, chips, counts and sheet: words and states, swapped in place. */
  function swapChrome(doc) {
    var form = document.getElementById('FacetFiltersForm');
    var nextForm = form && doc.getElementById(form.id);
    if (form && nextForm) {
      swapChips(form, doc);
      swapNode(form, nextForm);
    }
    [['.clp-count'], ['.plp-eyebrow']].forEach(function (pair) {
      var a = document.querySelector(pair[0]);
      var b = doc.querySelector(pair[0]);
      if (a && b && a.textContent !== b.textContent) {
        var m2 = motion();
        if (m2) m2.swapText(a, b.textContent); else a.textContent = b.textContent;
      }
    });
    var sheetPanel = document.querySelector('[data-plp-sheet] .plp-sheet-panel');
    var nextSheetPanel = doc.querySelector('[data-plp-sheet] .plp-sheet-panel');
    if (sheetPanel && nextSheetPanel) sheetPanel.innerHTML = nextSheetPanel.innerHTML;
    hookForms();
  }

  function applyOwned(url, push) {
    var grid = document.querySelector('[data-vro-shopby-grid]');
    var section = sectionOf(grid);
    var token = {};
    busy = token;

    var fetchUrl = new URL(url.toString());
    if (section) fetchUrl.searchParams.set('section_id', section);

    grid.classList.add('vro-filter-loading');
    closePanels();

    fetch(fetchUrl.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('filter ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (busy !== token) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-vro-shopby-grid]');
        if (!nextGrid) throw new Error('filter: no grid');

        if (push) history.pushState({ vroFilter: true }, '', url.toString());
        swapChrome(doc);

        /* The server's filtered grid is what Clear / Retake go back to;
           the rows and the answer rebuild on top of the filtered shelf. */
        var shop = window.VroPlpShopBy;
        shop.setOriginal(nextGrid.innerHTML);
        grid.classList.remove('vro-filter-loading');
        shop.refresh();

        document.dispatchEvent(new CustomEvent('vro:filters:updated', { detail: { url: url.toString() } }));
      })
      .catch(function () {
        if (busy === token) fullLoad(url);
      });
  }

  function apply(url, push) {
    /* VRO Luxe filters its own grid in place (sections/vro-luxe-prod-
       grid.liquid): the new URL goes in the address bar and the page is
       told, rather than reloaded. */
    var luxe = window.VroLuxeFilters;
    if (luxe && luxe.owns && luxe.owns(url) && history.pushState) {
      closePanels();
      if (push) history.pushState({ vroFilter: true }, '', url.toString());
      var lbar = document.querySelector('.clp-filterbar, .plp-filterbar');
      var lgrid = document.querySelector('[data-luxe-grid]');
      if (lbar && lgrid && lgrid.getBoundingClientRect().top < 0) {
        window.scrollTo({ top: lbar.getBoundingClientRect().top + window.pageYOffset - 8, behavior: reduced() ? 'auto' : 'smooth' });
      }
      document.dispatchEvent(new CustomEvent('vro:filters:updated', { detail: { url: url.toString() } }));
      return;
    }
    if (!canSwap(url)) {
      if (ownedByRows(url)) applyOwned(url, push);
      else fullLoad(url);
      return;
    }
    var grid = document.querySelector(GRID_SEL);
    var section = sectionOf(grid);
    var token = {};
    busy = token;

    var fetchUrl = new URL(url.toString());
    if (section) fetchUrl.searchParams.set('section_id', section);

    grid.classList.add('vro-filter-loading');
    closePanels();

    fetch(fetchUrl.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('filter ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (busy !== token) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector(GRID_SEL);
        if (!nextGrid) throw new Error('filter: no grid');
        var m = motion();
        var ready = m ? m.preload(nextGrid.querySelectorAll('.feed-card'), { limit: 8, timeout: 1500 }) : Promise.resolve();
        return ready.then(function () { return doc; });
      })
      .then(function (doc) {
        if (!doc || busy !== token) return;

        if (push) history.pushState({ vroFilter: true }, '', url.toString());

        swapChrome(doc);

        /* The products: a soft dip, the new set, the page easing to its
           new height, the cards settling in order. */
        var nextGrid = doc.querySelector(GRID_SEL);
        var put = function () {
          grid.innerHTML = nextGrid.innerHTML;
          var n = 0;
          Array.prototype.forEach.call(grid.querySelectorAll('.feed-card'), function (card) {
            if (n > 9) return;
            card.style.animationDelay = (n++ * 70) + 'ms';
            card.classList.add('vro-settle-in');
          });
          initBanners(grid);
        };
        /* The grid is already dimmed from the fetch; the new set goes in
           while it is, and it brightens as the height settles. */
        var m = motion();
        if (m) m.morphHeight(grid, put, { duration: 650 });
        else put();
        requestAnimationFrame(function () { grid.classList.remove('vro-filter-loading'); });

        if (window.VroWishlist && window.VroWishlist.sync) window.VroWishlist.sync();

        /* Keep the shopper where they are, unless the results now start
           above the screen — then bring the filter bar back into view. */
        var bar = document.querySelector('.clp-filterbar, .plp-filterbar');
        if (bar && grid.getBoundingClientRect().top < 0) {
          var top = bar.getBoundingClientRect().top + window.pageYOffset - 8;
          window.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' });
        }
        document.dispatchEvent(new CustomEvent('vro:filters:updated', { detail: { url: url.toString() } }));
      })
      .catch(function () {
        if (busy === token) fullLoad(url);
      });
  }

  function closePanels() {
    Array.prototype.forEach.call(document.querySelectorAll('.clp-filter-panel:not([hidden])'), function (p) {
      p.hidden = true;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-filter-pill][aria-expanded="true"]'), function (p) {
      p.setAttribute('aria-expanded', 'false');
    });
    var sheet = document.querySelector('[data-plp-sheet]');
    if (sheet && !sheet.hidden) closeSheet(sheet);
  }

  /* ---------- the ways in -------------------------------------------- */
  /* The bar's radios and checkboxes call form.submit() inline, which
     never fires a submit event — so the element's own submit is routed
     through here. Re-done after each swap, harmlessly. */
  function hookForms() {
    Array.prototype.forEach.call(document.querySelectorAll(FORM_SEL), function (form) {
      if (form.__vroHooked) return;
      form.__vroHooked = true;
      var native = HTMLFormElement.prototype.submit;
      form.submit = function () {
        try { apply(formUrl(form), true); } catch (e) { native.call(form); }
      };
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest(FORM_SEL) : null;
    if (!form || e.defaultPrevented) return;
    /* Never the browser's own GET: it would drop ?shop= / ?vroq= and
       blank the page. apply() swaps in place, or reloads softly. */
    e.preventDefault();
    apply(formUrl(form), true);
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;

    /* Applied-filter chips that are links, "Clear all" in the bar and the sheet. */
    var link = t.closest('.clp-active-filters a[href], a.clp-clear-filters[href], a.plp-sheet-clear[href]');
    if (link) {
      var url = carry(new URL(link.getAttribute('href'), window.location.href));
      e.preventDefault();
      e.stopPropagation();
      apply(url, true);
      return;
    }

    /* Price and sort chips: custom.js strips their params and reloads.
       Same URL, built the same way, handled here first. */
    var chip = t.closest('[data-remove-param]');
    if (chip) {
      var params = new URLSearchParams(window.location.search);
      (chip.getAttribute('data-remove-params') || '').split(',').forEach(function (name) {
        if (name) params.delete(name);
      });
      var next = new URL(window.location.pathname, window.location.href);
      next.search = params.toString();
      e.preventDefault();
      e.stopPropagation();
      apply(next, true);
    }
  }, true);

  /* Back and forward through filter steps: swapped like a filter, not
     reloaded. The Shop-by rows read their picks once, at load, so a step
     that changes ?shop= / ?vroq= themselves still reloads (softly). */
  var lastSearch = window.location.search;
  function ownedKeys(search) {
    var p = new URLSearchParams(search);
    return (p.get('shop') || '') + '|' + (p.get('vroq') || '');
  }
  window.addEventListener('popstate', function (e) {
    var was = lastSearch;
    lastSearch = window.location.search;
    if (!(e.state && e.state.vroFilter) && !document.documentElement.__vroFiltered) return;
    var url = new URL(window.location.href);
    if (ownedKeys(was) !== ownedKeys(url.search)) { fullLoad(url); return; }
    apply(url, false);
  });
  document.addEventListener('vro:filters:updated', function () {
    lastSearch = window.location.search;
  });
  document.addEventListener('vro:filters:updated', function () {
    document.documentElement.__vroFiltered = true;
  });

  /* ---------- the all-filters sheet ----------------------------------- */
  function closeSheet(sheet) {
    if (sheet.hidden || sheet.classList.contains('is-leaving')) return;
    if (reduced()) {
      sheet.hidden = true;
      document.body.style.overflow = '';
      return;
    }
    sheet.classList.remove('is-entering');
    sheet.classList.add('is-leaving');
    setTimeout(function () {
      sheet.hidden = true;
      sheet.classList.remove('is-leaving');
      document.body.style.overflow = '';
    }, 260);
  }

  function watchSheet() {
    var sheet = document.querySelector('[data-plp-sheet]');
    if (!sheet || sheet.__vroWatched || !window.MutationObserver) return;
    sheet.__vroWatched = true;
    new MutationObserver(function () {
      if (!sheet.hidden && !sheet.classList.contains('is-leaving')) {
        sheet.classList.remove('is-entering');
        void sheet.offsetWidth;
        sheet.classList.add('is-entering');
      }
    }).observe(sheet, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* Closing is intercepted before plp-category.js hides it outright, so
     it can slide away first. */
  document.addEventListener('click', function (e) {
    var sheet = document.querySelector('[data-plp-sheet]');
    if (!sheet || sheet.hidden) return;
    if (e.target.closest && e.target.closest('[data-plp-sheet-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeSheet(sheet);
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    var sheet = document.querySelector('[data-plp-sheet]');
    if (e.key === 'Escape' && sheet && !sheet.hidden) {
      e.stopPropagation();
      closeSheet(sheet);
    }
  }, true);

  function init() {
    restoreScroll();
    hookForms();
    watchSheet();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.VroFilterMotion = { apply: function (href) { apply(new URL(href, window.location.href), true); } };
})();
